<div class="col-12 col-md-12 mb-4">
    <div class="card rounded-top-left-0">
        <div class="card-header d-flex justify-start items-center gap-2">
            <h3>Asignar Destino a Bodega</h3>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <div class="row mb-4">
                        <div class="col-6 form-group mb-4">
                            <label for="product-order" class="form-label">Destino</label>
                            <div class="input-group bg-white rounded">
                                <app-input-autocomplete
                                    [allBorderRadius]="true"
                                    [inputs]="inputs.destination"
                                    [placeholder]="'Ingresa un destino'"
                                    [filterElements]="filterDestination"
                                    (inputMethod)="writeDestination($event.event)"
                                    (changeStatus)="checkDestination($event.filterElement)"
                                    (getTitle)="
                                        $event.filterElement.title =
                                            $event.filterElement.name
                                    "
                                ></app-input-autocomplete>
                            </div>
                        </div>
                        <div class="col-6 form-group mb-4">
                            <label for="product-order" class="form-label">Bodega</label>
                            <div class="input-group bg-white rounded">
                                <app-input-autocomplete
                                    [allBorderRadius]="true"
                                    [inputs]="inputs.warehouse"
                                    [placeholder]="'Ingresa una bodega'"
                                    [filterElements]="filterWarehouse"
                                    (inputMethod)="writeWarehouse($event.event)"
                                    (changeStatus)="checkWarehouse($event.filterElement)"
                                    (getTitle)="
                                        $event.filterElement.title =
                                            $event.filterElement.code +
                                            ' - ' +
                                            $event.filterElement.name
                                    "
                                ></app-input-autocomplete>
                            </div>
                        </div>

                        <div class="col-6 form-group mb-4">
                            <label for="product-order" class="form-label">Fecha Inicio</label>
                            <input type="date" class="form-control" [(ngModel)]="startDate"/>
                        </div>
                        <div class="col-6 form-group mb-4">
                            <label class="form-label">Fecha Fin</label>
                            <input type="date" class="form-control" [(ngModel)]="endDate" />
                        </div>

                        <div class="col-12 d-flex flex-row mb-4 justify-end">
                            <button class="btn btn-success" (click)="createAddAsociation()"
                                [disabled]="loadingCreate || !verifyForm ">
                                <ng-container *ngIf="!loadingCreate">
                                    <i class="fa fa-floppy-disk"></i>
                                </ng-container>
                                <ng-container *ngIf="loadingCreate">
                                    <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                    <span role="status"></span>
                                </ng-container> GUARDAR
                            </button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="table-responsive" style="margin-bottom: 0; overflow-y: inherit; max-height: none;" *ngIf="this.inputs.warehouse.verified">
                            <h3>Asignaciones Vigentes de la Bodega</h3>
                            <table class="table table-striped" style="margin-bottom: 0; margin-top: 10px;">
                                <thead>
                                    <tr class="tr-middle">
                                        <th class="ta">
                                            Bodega
                                        </th>
                                        <th class="limit-td">
                                            Inicia
                                        </th>
                                        <th class="ta">
                                            Termina
                                        </th>
                                        <th class="ta">
                                            Destino
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngIf="!loadingAssings">
                                        <tr class="tr-middle" *ngFor="let item of assigsActive">
                                            <td class="col">
                                                {{item.warehouseData.name}}
                                            </td>
                                            <td class="col">
                                                {{item.effectiveDate | date:'dd-MM-YYYY HH:mm:ss'}}
                                            </td>
                                            <td class="col">
                                                {{item.expirationDate | date:'dd-MM-YYYY HH:mm:ss'}}
                                            </td>
                                            <td class="col">
                                                {{item.destinationData.name}}
                                            </td>
                                        </tr>
                                        <tr class="tr-middle" *ngIf="assigsActive.length==0">
                                            <td colspan="4" class="">
                                                <span class="text-center">
                                                    No se encuentras asignaciones vigentes
                                                </span>
                                            </td>
                                        </tr>
                                    </ng-container>
                                    <tr class="tr-middle" *ngIf="loadingAssings">
                                        <td colspan="4" class="">
                                            <span class="display-5 text-center">
                                                <app-loading-animation [height]="'3rem'"></app-loading-animation>
                                                Cargando...
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>